<template>
  <div class="booking-container">
    <img
      class="left"
      :src="require('@/assets/images/HomePage/siedbar/left.png')"
      alt="左边图片加载失败"
    />
    <div class="right">
      <template v-if="!isSubmit">
        <div class="title">预约试用产品</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="ruleForm"
          :inline-message="true"
          hide-required-asterisk
          :show-message="true"
        >
          <el-form-item label="您的姓名" prop="name">
            <el-input v-model="ruleForm.name">
            </el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company">
            <el-input v-model="ruleForm.company"></el-input>
          </el-form-item>
          <el-form-item label="所属地区" prop="region">
            <el-cascader
              ref="cityCascader"
              v-model="ruleForm.region"
              clearable
              size="mini"
              :props="cascaderProp"
              @change="cityChange"
              placeholder="全部"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="所属行业" prop="industry">
            <el-select v-model="ruleForm.industry" clearable>
              <el-option v-for="item in industryList" :key="item.value" :label="item.label" :value="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="texta" label="预约说明" prop="desc">
            <el-input type="textarea" placeholder="贵企业的业务需求" v-model="ruleForm.desc"></el-input>
          </el-form-item>
          <el-form-item class="btn">
            <el-button class="submitBtn" @click="submitForm('ruleForm')"
              >提交预约</el-button
            >
          </el-form-item>
        </el-form>
        <div class="tips">
          预约提交后，我们将尽快为您处理，请耐心等待工作人员联系
        </div>
      </template>

      <div class="isSubmit" v-else>
        <svg-icon icon-class="check"/>
        <div class="title">预约提交成功</div>
        <div class="tips">
          我们将尽快为您处理，请耐心等待工作人员联系
        </div>
        <div class="btn" @click="close">
          知道了
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { adminRegionArRegion} from "@/api/user";
import axios from "axios";

export default {
  data() {
    return {
      ruleForm: {
        name: "",
        region: "全部",
        phone: "",
        company: "",
        industry: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[34578]\d{9}$/,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
      },
      // 所属地列表
      cascaderProp: {
        checkStrictly: true,
        lazy: true,
        lazyLoad(node, resolve) {
          // console.log(node, resolve);
          const { level, value } = node;

          if (node.level == 0) {
            axios.post('https://flyseebeta.guihuao.com/alpha/back/v1/kanban/adminregion/ar_region',{
              parent_id: 0
            }).then((res) => {
              if (res.data.error_code === 0) {
                if (res.data.data?.length > 0) {
                  let nodes = [];
                  res.data.data.forEach((item) => {
                    nodes.push({
                      // value: item.ar_id,
                      value: item,
                      label:
                        item.ar_name
                        //  +
                        // `${
                        //   item.nest_num === 0 ? "" : "(" + item.nest_num + ")"
                        // }`
                        ,
                      leaf: false,
                    });
                  });
                  console.log(nodes);
                  resolve(nodes);
                }
              }
            });
          } else {
            axios.post('https://flyseebeta.guihuao.com/alpha/back/v1/kanban/adminregion/ar_region',{
              parent_id: value.ar_id
            }).then((res) => {
              if (res.data.error_code === 0) {
                if (res.data.data?.length > 0) {
                  let nodes = [];
                  res.data.data.forEach((item) => {
                    nodes.push({
                      // value: item.ar_id,
                      value: item,
                      label:
                        item.ar_name 
                        // +
                        // `${
                        //   item.nest_num === 0 ? "" : "(" + item.nest_num + ")"
                        // }`
                        ,
                      leaf: level >= 3,
                    });
                  });
                  resolve(nodes);
                }
              }
            });
          }
        },
      },
      // 所属行业
      industryList: [
        { label: "公共安全", value: 0 },
        { label: "城市管理", value: 1 },
        { label: "消防救援", value: 2 },
        { label: "生态环境保护", value: 3 },
        { label: "农业自然资源普查", value: 4 },
        { label: "应急应用", value: 5 },
        { label: "矿业应用", value: 6 },
        { label: "石油应用", value: 7 },
      ],
      isSubmit: false, // 是否已提交
    };
  },
  mounted() {
  },
  methods: {
    // 变更城市
    cityChange(val) {
      if (val) {
        console.log(this.ruleForm.region, val);
        // this.filterOrgDept();
        this.ruleForm.region.path = val[val.length - 1];
      }
      // 解决：el-cascader当设置了checkStrictly:true属性时，可以选择任意一级的菜单。但是同时设置动态加载的时候。点击前面的radio按钮会出现一个暂无数据的面板
      const panelRefs = this.$refs.cityCascader.$refs.panel;
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach((item) => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0]);
          }
        });
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let city = ''
          if(Array.isArray(this.ruleForm.region) && this.ruleForm.region.length === 0 || this.ruleForm.region == '全部'){
            city = ''
          }else{
            city = this.ruleForm.region.map((item) => item.ar_name).join('');
          }
          axios.post('https://flyseebeta.guihuao.com/alpha/back/v1/oth/website/contact',{
            name: this.ruleForm.name,
            phone: this.ruleForm.phone,
            company: this.ruleForm.company,
            city,
            industry: this.ruleForm.industry,
            remark: this.ruleForm.desc,
          }).then((res) => {
            if(res.data.error_code === 0){
              this.isSubmit = true
            }else{
              this.$message.error(res.data.msg)
            }
          }).catch((error) => {
            if (error.response) {
              // 请求已发出，但服务器响应的状态码不在 2xx 范围内
              this.$message.error('手机号格式不正确！')
            } else {
              console.log('Error', error.message);
            }
          })
        } else {
          this.$message.error("请填写完整信息");
          return false;
        }
      });
    },

    close(){
      this.$emit('close')
    },
  },
};
</script>


<style lang="scss" scoped>
.booking-container {
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0); // 白色背景，50%透明度
  box-shadow: 0 6px 40px 0 #0000001a;
  border-radius: 16px;
  display: flex;

  .left {
    width: vw(336);
    height: 100%;
    border-radius: 16px 0 0 16px;
  }

  .right {
    flex: vw(444);
    height: 100%;
    background-color: #ffffff;
    border-radius: 0 16px 16px 0;
    padding: 24px 32px 18px 32px;
    .title{
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 32px;
      margin-bottom: 20px;
    }
    .ruleForm ::v-deep{
      position: relative;
      .el-form-item__label{
        position: absolute;
        left: 12px;
        z-index: 1;
        font-weight: 400;
        font-size: 14px;
        color: #00000099;
        letter-spacing: 0;
      }
      .el-input__inner{
        padding-left: 85px;
        background: #0000000d;
        border-radius: 12px;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        height: 40px;
        line-height: 20px;
      }
      .el-form-item__content{
        height: 54px;
      }
      .el-input{
        margin-bottom: 12px;
      }
      .el-cascader .el-input .el-icon-arrow-down{
        color: #1D1D1F;
      }
      .is-required .el-form-item__label::after {
        content: "*";
        color: #ff0000;
        margin-left: 4px;
      }
      .texta{
        .el-form-item__content{
          height: 88px;
        }
      }
      .el-textarea__inner{
        height: 88px;
        background: #0000000d;
        border-radius: 12px;
        padding-top: 42px;
      }
      .el-select .el-input .el-select__caret{
        color: #000000;
      }
      .btn{
        display: flex;
        justify-content: center;
        .submitBtn{
          margin-top: 16px;
          margin-bottom: 18px;
          width: 260px;
          height: 44px;
          background: #1D1D1F;
          border-radius: 24px;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          &:hover{
            background: #0271E3;
          }
        }
      }
    }
    .tips{
      font-weight: 400;
      font-size: 12px;
      color: #00000099;
      letter-spacing: 0;
      text-align: center;
      line-height: 20px;
      margin-top: 15px;
    }
    .isSubmit{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 100px;
      .svg-icon{
        font-size: 64px;
        margin-bottom: 16px;
      }
      .title{
        font-weight: 500;
        font-size: 20px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
        margin-bottom: 12px;
      }
      .tips{
        font-weight: 400;
        font-size: 14px;
        color: #00000099;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
        margin-bottom: 60px;
      }
      .btn{
        width: 260px;
        height: 44px;
        background: #1D1D1F;
        border-radius: 24px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
        &:hover{
          background: #0271E3;
        }
      }
    }
  }
}
::v-deep{
  .el-form .el-form-item.is-error .el-form-item__error{
    display: block !important;
    top: -15px;
  }
}
</style>